import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Shell } from '../../components/layout/Shell';
import { api } from '../../lib/api';
import { FitBadge } from '../../components/hikari/ScoreBreakdown';
import { Briefcase, MapPin, CheckCircle } from '@phosphor-icons/react';

const STATUS_STYLE = {
  applied: 'bg-secondary text-foreground',
  invite: 'bg-primary text-primary-foreground',
  hire: 'bg-foreground text-background',
  reject: 'bg-muted text-muted-foreground',
};

const CandidateApplications = () => {
  const [apps, setApps] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get('/applications/mine').then((r) => setApps(r.data)).finally(() => setLoading(false));
  }, []);

  return (
    <Shell>
      <div className="max-w-[1200px] mx-auto px-6 py-10">
        <div className="label-eyebrow text-primary mb-2">YOUR APPLICATIONS</div>
        <h1 className="font-display font-black text-4xl tracking-tighter mb-8">Track where you stand.</h1>

        {loading ? (
          <div className="mono text-sm text-muted-foreground">Loading...</div>
        ) : apps.length === 0 ? (
          <div className="border border-border bg-white p-10 text-center">
            <div className="label-eyebrow text-muted-foreground mb-2">NO APPLICATIONS YET</div>
            <p className="text-sm text-muted-foreground mb-4">Complete an assessment in a role family, then apply to a matching job.</p>
            <Link to="/candidate/jobs" className="label-eyebrow text-primary">BROWSE JOBS →</Link>
          </div>
        ) : (
          <div className="border border-border" data-testid="applications-list">
            {apps.map((a) => (
              <div key={a.id} className="p-5 bg-white border-b border-border flex items-center gap-4 flex-wrap" data-testid={`app-${a.id}`}>
                <div className="w-16">
                  {a.score ? <FitBadge value={a.score.overall_fit} size="sm" /> : <div className="mono text-xs text-muted-foreground">—</div>}
                </div>
                <div className="flex-1 min-w-0">
                  <div className="font-display font-black text-lg">{a.job?.title || '(removed)'}</div>
                  <div className="mono text-xs text-muted-foreground flex items-center gap-1 mt-1">
                    <MapPin size={12} /> {a.job?.location || '—'} · {a.job?.country || '—'} · {(a.job?.source || '').toUpperCase()}
                  </div>
                </div>
                <div className={`label-eyebrow px-3 py-1 ${STATUS_STYLE[a.status] || STATUS_STYLE.applied}`}>{a.status}</div>
              </div>
            ))}
          </div>
        )}
      </div>
    </Shell>
  );
};

export default CandidateApplications;
